import { render, staticRenderFns } from "./rate-list-history.vue?vue&type=template&id=ef38b2cc"
import script from "./rate-list-history.vue?vue&type=script&lang=js"
export * from "./rate-list-history.vue?vue&type=script&lang=js"
import style0 from "./rate-list-history.vue?vue&type=style&index=0&id=ef38b2cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports